import { routes as nestedRoutes } from './:payInMethodId'

export const routes = {
  ...nestedRoutes,
} as const
